import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" }
};

const ADD = "add";
const GET = "get";
const GETBYID = "getbyid";
const DELETE = "delete";
const EDIT='edit'

export default {
addAchievement(payload) {
   return Repository.post(transformRoute(ADD), payload,formDataConfig);
  },
getAchievement(payload) {
return Repository.get(transformRoute(GET),  { params: payload });
  },
  getAchievementById(payload) {
    return Repository.get(transformRoute(GETBYID),  { params: payload });
      },
    
deleteAchievement(payload) {
return Repository.post(transformRoute(DELETE),payload);
  },

  editAchievement(payload) {
    return Repository.post(transformRoute(EDIT), payload,formDataConfig);
   },


};


const transformRoute = route => {
  return `/achievement/${route}`;
};
